import type { TFunction } from "@/hooks/useTranslation"

export const getModalProps = (t: TFunction) => ({
  width: 550,
  icon: null,
  rootClassName: "self-hosted-user-modal-ks",
  okText: t("general.finish")
})
